module.exports = __webpack_public_path__ + "img/us.ecdc9c9e.svg";